(function () {
  'use strict';

  function setStatus(section, message) {
    var status = section.querySelector('[data-chd-related-cart-status]');

    if (status) {
      status.textContent = message;
      status.hidden = !message;
    }
  }

  function getCart() {
    return fetch(window.routes.cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Could not read cart');
      }

      return response.json();
    });
  }

  function addVariant(variantId) {
    return window.chdStock.requestAdd(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify({ id: variantId, quantity: 1 }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Could not add variant');
      }

      return response.json();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-chd-drilling-template-add]');

    if (!button || (window.theme && window.theme.cartType === 'page')) {
      return;
    }

    event.preventDefault();

    if (button.getAttribute('aria-busy') === 'true') {
      return;
    }

    var section = button.closest('[data-section-type="product-recommendations"]');
    var variantId = button.getAttribute('data-variant-id');

    if (!section || !variantId) {
      return;
    }

    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    setStatus(section, '');

    getCart().then(function (cart) {
      var alreadyInCart = cart.items.some(function (item) {
        return String(item.variant_id) === String(variantId);
      });

      if (alreadyInCart) {
        setStatus(section, button.dataset.alreadyLabel);
        section.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return null;
      }

      return addVariant(variantId);
    }).then(function (item) {
      if (!item) {
        return;
      }

      setStatus(section, button.dataset.addedLabel);
      section.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { button: button, variant: item, quantity: 1 }
      }));
    }).catch(function () {
      setStatus(section, button.dataset.errorLabel);
    }).finally(function () {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    });
  });
})();
